<template>
  <div class="pt-5" style="max-width: 400px;">
    <vue-headful title="Einrichtung" description="Aimz"/>
    <v-form>
      <v-row>
        <v-col>
          <header1 class="mt-5">Einrichtung</header1>
          <div class="ml-5 mr-5 mt-5">
            <p>
              Hi Champ,
            </p>
<!--            <p>-->
<!--              bevor du loslegst, lass mich noch ein paar Worte über aimz verlieren.-->
<!--            </p>-->
            <p>
              Der Weg zu deinem Glück führt über deine <b>Lebensziele</b>. Nimm dir die Zeit, die für dich
              wesentlichen Lebenssäulen zu definieren und stelle dir die Frage, mit welchen <b>Aktivitäten</b> du
              deine unterschiedlichen Rollen gut ausleben kannst.
            </p>
            <p>
              Diese Grundlagen sind <b>das Fundament eines glücklichen Lebens.</b> Nur wer genau weiß wo
              er hin will, hat eine Chance, sein Ziel auch zu erreichen.
            </p>
            <p>
              Wenn du alles eingerichtet hast, brauchst du nur mehr deine Aktivitäten eingeben. <b>Wenige
              Minuten pro Tag</b> reichen und du hast den vollen Überblick!
            </p>
            <p>
              Am Ende jeder Woche siehst du dann im <b>Dashboard</b> oder im <b>Wochenbericht</b>, ob und in
              welchen Lebensbereichen du nach deinen eigenen Vorstellungen lebst. Dieses Feedback wird
              dir helfen, dein eigenes Lebensglück zu finden.
            </p>
            <p>
              Josef und dein aimz-Team<br>
              Next Stop – Happiness!
            </p>
            <v-text-field class="mt-5" v-model="user_data.username" outlined label="Benutzername"></v-text-field>
          </div>


        </v-col>
      </v-row>
    </v-form>
    <v-row v-if="showSaveBtn" class="mx-0 d-flex" style="min-height: 40px;" >
      <v-btn v-if="changed" dark @click="save" class="mx-auto mb-5">Speichern</v-btn>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import Header1 from "@/components/Header1";

const CONTEXT = "@user_profile";

export default {
  name: 'UserData',
  components: { Header1 },
  props: ['show_save_btn'],
  data: () => ({
    loading:false,
    error:false,
    reason:false,
    changed:false,
    user_data_orig: {},
    showSaveBtn:true,
    user_data: {
      username: undefined,
      sex: undefined,
      birthyear: undefined,
      country: undefined,
      which_country: undefined,
      zip: undefined,
      family: undefined,
      num_kids: 0,
      kids: [],
      job: undefined,
      workhours: 0,
      education: undefined,
    },
    nkids: 0,
    kids:{ kid0:undefined, kid1:undefined,kid2:undefined,kid3:undefined,kid4:undefined,kid5:undefined,kid6:undefined,kid7:undefined,kid8:undefined,kid9:undefined,},
    sex_options: ['männlich', 'weiblich'],
    country_options: ['Deutschland', 'Österreich', 'Schweiz', 'Lichtenstein', 'Italien', 'Anderes Land'],
    family_options: ['Single', 'In Beziehung',],
    job_options: ['Angestellter', 'Selbständig',],
    education_options: ['Pflichtschule', 'Lehre', 'Matura/Abitur', 'Universität/Fachhochschule'],
    year_options: [],
  }),
  mounted() {
    if (this.show_save_btn===false)
      this.showSaveBtn=false;
    // fill year_options with past 100 years (allowing 16 .. 100 year olds)
    var start = new Date().getFullYear() - 101;
    for (var i = (100 - 15); i > 0; i--)
      this.year_options.push(start + i);
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      var data=await this.$backend.get_settings(CONTEXT, {onError: this.onLoadError});
      this.loading = false;
      if (data) {
        data.kids ||= []; // make sure it is an array
        this.user_data_orig = data;
        this.user_data = JSON.parse(JSON.stringify(data));
        (this.user_data_orig.kids || []).forEach((year, i) => {
          this.kids['kid' + i] = year;
        })
        // after loading must assign nkids from user_data!!!
        this.nkids = this.user_data.num_kids;
        this.user_data.username ||= this.$app.user.name;
      }
    },
    onLoadError(reason) {
      this.loading = false;
      this.user_data = {};
      this.error = true;
      this.reason = reason;
    },
    async save() {
      this.loading = true;
      await this.$backend.set_settings(CONTEXT, this.user_data, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError,
        no_notify:true,
      });
      this.load();
    },
    canContinue() {
      if (!this.user_data.username) {
        this.$events.$emit("error", "Der Benutzername wird benötigt, muss aber nicht dein wirklicher Name sein.")
        return false;
      }
      return true;
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.user_data_orig = data;
      this.user_data = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
  },
  computed: {},
  watch: {
    nkids(n, o) {
      this.user_data.num_kids = n;
    },
    kids: {
      deep: true,
      handler(n, o) {
        var kids = []
        for(var i=0; i<this.nkids; i++){
          var year=this.kids['kid'+i]||"";
          kids.push(year);
        }
        this.user_data.kids=kids;
      }
    },
    user_data: {
      deep: true,
      handler() {
        this.changed = JSON.stringify(this.user_data_orig) !== JSON.stringify(this.user_data);
      }
    }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>